import { useSelector } from 'react-redux';

import type { RootState } from 'store';

import { AuthUserType } from 'common/graphql/types';

import { useQuery } from '../../hooks/useQuery';
import type { DCRConfig } from '../types/types';

import { getDCRConfigQuery } from './queries';

export function useDCRConfig(studyId: string, siteId: string) {
    const auth = useSelector((state: RootState) => state.auth);

    const shouldFetch = Boolean(
        studyId && auth.activeUser?.type !== AuthUserType.PATIENT && auth?.patientAccess?.status === 'IDLE'
    );

    const { data, isLoading } = useQuery<DCRConfig>(getDCRConfigQuery, {
        variables: {
            input: {
                studyId,
                siteId,
            },
        },
        queryString: 'getDCRConfig',
        skip: !shouldFetch,
    });

    return {
        dcrConfig: data,
        isLoading,
    };
}
